export class ContactRequest {
  RegisterType: number;
  Document: string;
  Name: string;
  LastName: string;
  SecondName: string;
  Email: string;
  Phone: string;
  District: number;
  Address: string;
  TypeId: number;
  ThemeId: number;
  SureId: number;
  Detail: string;
  Request: string;
  TypeClientId: number;
  Date: string;
  ContacWay: ContactWay[];
  DateRegister ?: string;
  LicensePlate ?: string;
}

export class ContactWay {
  ContacWayId: number;
}

export class ContactRequiredFilter {
  Code: string;
}
